import { bimCategoryParamsAPI } from "@/views/BimCategoryParams/services/api";
import { getBimCategories } from "@/views/BimCategories/services";

export const getBimCategoryParams = async (bim_category_id) => {
  try {
    const res = await bimCategoryParamsAPI.getParams(bim_category_id);
    return res?.data;
  } catch (e) {
    console.error('Error getting category params:', e);
    throw e;
  }
};

export const getAllBimParams = async () => {
  try {
    const res = await bimCategoryParamsAPI.getAllParams();
    return res?.data;
  } catch (e) {
    console.error('Error getting all params:', e);
    throw e;
  }
};

export const saveBimCategoryParam = async (data) => {
  try {
    const res = await bimCategoryParamsAPI.saveParam(data);
    return res;
  } catch (e) {
    console.error('Error saving category param:', e);
    throw e;
  }
};

export const deleteBimCategoryParam = async (bim_category_param_id) => {
  try {
    const res = await bimCategoryParamsAPI.deleteParam(bim_category_param_id);
    return res;
  } catch (e) {
    console.error('Error deleting category param:', e);
    throw e;
  }
};

export { getBimCategories };
